import { render } from "./SalesMobil.vue?vue&type=template&id=c8a18c48&scoped=true"
import script from "./SalesMobil.vue?vue&type=script&lang=js"
export * from "./SalesMobil.vue?vue&type=script&lang=js"

import "./SalesMobil.vue?vue&type=style&index=0&id=c8a18c48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8a18c48"]])

export default __exports__